export const COUNTRIES_CODE: any = {
  Afghanistan: 'AFG',
  Albania: 'ALB',
  Algeria: 'DZA',
  Andorra: 'AND',
  Angola: 'AGO',
  'Antigua and Barbuda': 'ATG',
  Argentina: 'ARG',
  Armenia: 'ARM',
  Australia: 'AUS',
  Austria: 'AUT',
  Azerbaijan: 'AZE',
  Bahamas: 'BHS',
  Bahrain: 'BHR',
  Bangladesh: 'BGD',
  Barbados: 'BRB',
  Belarus: 'BLR',
  Belgium: 'BEL',
  Belize: 'BLZ',
  Benin: 'BEN',
  Bhutan: 'BTN',
  Bolivia: 'BOL',
  'Bosnia and Herzegovina': 'BIH',
  Botswana: 'BWA',
  Brazil: 'BRA',
  Brunei: 'BRN',
  Bulgaria: 'BGR',
  'Burkina Faso': 'BFA',
  Burundi: 'BDI',
  'Cape Verde': 'CPV',
  Cambodia: 'KHM',
  Cameroon: 'CMR',
  Canada: 'CAN',
  'Central African Republic': 'CAF',
  Chad: 'TCD',
  Chile: 'CHL',
  China: 'CHN',
  Colombia: 'COL',
  Comoros: 'COM',
  Congo: 'COG',
  'Costa Rica': 'CRI',
  "Côte d'Ivoire": 'CIV',
  Croatia: 'HRV',
  Cuba: 'CUB',
  Cyprus: 'CYP',
  'Czech Republic': 'CZE',
  Denmark: 'DNK',
  Djibouti: 'DJI',
  Dominica: 'DMA',
  'Dominican Republic': 'DOM',
  Ecuador: 'ECU',
  Egypt: 'EGY',
  'El Salvador': 'SLV',
  'Equatorial Guinea': 'GNQ',
  Eritrea: 'ERI',
  Estonia: 'EST',
  Eswatini: 'SWZ',
  Ethiopia: 'ETH',
  Fiji: 'FJI',
  Finland: 'FIN',
  France: 'FRA',
  Gabon: 'GAB',
  Gambia: 'GMB',
  Georgia: 'GEO',
  Germany: 'D',
  Ghana: 'GHA',
  Greece: 'GRC',
  Grenada: 'GRD',
  Guatemala: 'GTM',
  Guinea: 'GIN',
  'Guinea-Bissau': 'GNB',
  Guyana: 'GUY',
  Haiti: 'HTI',
  Honduras: 'HND',
  Hungary: 'HUN',
  Iceland: 'ISL',
  India: 'IND',
  Indonesia: 'IDN',
  Iran: 'IRN',
  Iraq: 'IRQ',
  Ireland: 'IRL',
  Israel: 'ISR',
  Italy: 'ITA',
  Jamaica: 'JAM',
  Japan: 'JPN',
  Jordan: 'JOR',
  Kazakhstan: 'KAZ',
  Kenya: 'KEN',
  Kiribati: 'KIR',
  'North Korea': 'PRK',
  'South Korea': 'KOR',
  Kuwait: 'KWT',
  Kyrgyzstan: 'KGZ',
  Laos: 'LAO',
  Latvia: 'LVA',
  Lebanon: 'LBN',
  Lesotho: 'LSO',
  Liberia: 'LBR',
  Libya: 'LBY',
  Liechtenstein: 'LIE',
  Lithuania: 'LTU',
  Luxembourg: 'LUX',
  Madagascar: 'MDG',
  Malawi: 'MWI',
  Malaysia: 'MYS',
  Maldives: 'MDV',
  Mali: 'MLI',
  Malta: 'MLT',
  'Marshall Islands': 'MHL',
  Mauritania: 'MRT',
  Mauritius: 'MUS',
  Mexico: 'MEX',
  Micronesia: 'FSM',
  Moldova: 'MDA',
  Monaco: 'MCO',
  Mongolia: 'MNG',
  Montenegro: 'MNE',
  Morocco: 'MAR',
  Mozambique: 'MOZ',
  Myanmar: 'MMR',
  Namibia: 'NAM',
  Nauru: 'NRU',
  Nepal: 'NPL',
  Netherlands: 'NLD',
  'New Zealand': 'NZL',
  Nicaragua: 'NIC',
  Niger: 'NER',
  Nigeria: 'NGA',
  'North Macedonia': 'MKD',
  Norway: 'NOR',
  Oman: 'OMN',
  Pakistan: 'PAK',
  Palau: 'PLW',
  Panama: 'PAN',
  'Papua New Guinea': 'PNG',
  Paraguay: 'PRY',
  Peru: 'PER',
  Philippines: 'PHL',
  Poland: 'POL',
  Portugal: 'PRT',
  Qatar: 'QAT',
  Romania: 'ROU',
  Russia: 'RUS',
  Rwanda: 'RWA',
  'Saint Kitts and Nevis': 'KNA',
  'Saint Lucia': 'LCA',
  'Saint Vincent and the Grenadines': 'VCT',
  Samoa: 'WSM',
  'San Marino': 'SMR',
  'São Tomé and Príncipe': 'STP',
  'Saudi Arabia': 'SAU',
  Senegal: 'SEN',
  Serbia: 'SRB',
  Seychelles: 'SYC',
  'Sierra Leone': 'SLE',
  Singapore: 'SGP',
  Slovakia: 'SVK',
  Slovenia: 'SVN',
  'Solomon Islands': 'SLB',
  Somalia: 'SOM',
  'South Africa': 'ZAF',
  'South Sudan': 'SSD',
  Spain: 'ESP',
  'Sri Lanka': 'LKA',
  Sudan: 'SDN',
  Suriname: 'SUR',
  Sweden: 'SWE',
  Switzerland: 'CHE',
  Syria: 'SYR',
  Taiwan: 'TWN',
  Tajikistan: 'TJK',
  Tanzania: 'TZA',
  Thailand: 'THA',
  'Timor-Leste': 'TLS',
  Togo: 'TGO',
  Tonga: 'TON',
  'Trinidad and Tobago': 'TTO',
  Tunisia: 'TUN',
  Turkey: 'TUR',
  Turkmenistan: 'TKM',
  Tuvalu: 'TUV',
  Uganda: 'UGA',
  Ukraine: 'UKR',
  'United Arab Emirates': 'ARE',
  'United Kingdom': 'GBR',
  'United States': 'USA',
  Uruguay: 'URY',
  Uzbekistan: 'UZB',
  Vanuatu: 'VUT',
  Venezuela: 'VEN',
  Vietnam: 'VNM',
  Yemen: 'YEM',
  Zambia: 'ZMB',
  Zimbabwe: 'ZWE'
};

export const SERVICE_TRANSACTION_CODE: string[] = ['211', '120', '121', '210', '270'];
export const PAYMENT_AND_REFUND_TRANSACTION_CODE = [
  '10',
  '11',
  '20',
  '21',
  '12',
  '13',
  '22',
  '40',
  '41',
  '42'
];
export const ROOM_CHARGE_TRANSACTION_CODE = ['110'];

export enum LanguageEnum {
  VIETNAMESE = 'vi',
  FRENCH = 'fr',
  CHINESE = 'zh_CN',
  JAPANESE = 'ja',
  SPANISH = 'es',
  ENGLISH = 'en'
}

export const getLanguageLabels = (t: (key: string) => string): Record<LanguageEnum, string> => ({
  [LanguageEnum.VIETNAMESE]: t('common.language.vi'),
  [LanguageEnum.FRENCH]: t('common.language.fr'),
  [LanguageEnum.CHINESE]: t('common.language.zh'),
  [LanguageEnum.JAPANESE]: t('common.language.ja'),
  [LanguageEnum.SPANISH]: t('common.language.es'),
  [LanguageEnum.ENGLISH]: t('common.language.en')
});

export const SERVICES_PRODUCT_ID = {
  transportation: 3313,
  tote_bag: 3613
};

export const SERVICES_PRODUCT_NAME = {
  transportation: 'managePage.consolidateRevenueReportPage.services.transportation',
  tote_bag: 'managePage.consolidateRevenueReportPage.services.tote_bag'
};

export const SERVICES_PRODUCT_ID_TO_NAME = {
  [SERVICES_PRODUCT_ID.transportation]: SERVICES_PRODUCT_NAME.transportation,
  [SERVICES_PRODUCT_ID.tote_bag]: SERVICES_PRODUCT_NAME.tote_bag
};

export const getServiceProductIdOptions = (t: (key: string) => string) => {
  return Object.values(SERVICES_PRODUCT_ID).map(value => ({
    label: t(SERVICES_PRODUCT_ID_TO_NAME[value as keyof typeof SERVICES_PRODUCT_ID_TO_NAME]),
    value
  }));
};

export const CURRENCIES = {
  AED: {
    symbolNative: 'د.إ.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  AFN: {
    symbolNative: '؋',
    minorSingle: 'Pul',
    minorPlural: 'Pul'
  },
  ALL: {
    symbolNative: 'L',
    minorSingle: 'Qindarka',
    minorPlural: 'Qindarka'
  },
  AMD: {
    symbolNative: 'դր',
    minorSingle: 'Luma',
    minorPlural: 'Luma'
  },
  ANG: {
    symbolNative: 'ƒ',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  AOA: {
    symbolNative: 'Kz',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos'
  },
  ARS: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  AUD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  AWG: {
    symbolNative: 'ƒ',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  AZN: {
    symbolNative: '₼',
    minorSingle: 'Qapik',
    minorPlural: 'Qapik'
  },
  BAM: {
    symbolNative: 'КМ',
    minorSingle: 'Fening',
    minorPlural: 'Fening'
  },
  BBD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  BDT: {
    symbolNative: '৳',
    minorSingle: 'Poisha',
    minorPlural: 'Poisha'
  },
  BGN: {
    symbolNative: 'лв.',
    minorSingle: 'Stotinka',
    minorPlural: 'Stotinki'
  },
  BHD: {
    symbolNative: 'د.ب.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  BIF: {
    symbolNative: 'FBu',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  BMD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  BND: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  BOB: {
    symbolNative: 'Bs.',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  BRL: {
    symbolNative: 'R$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  BSD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  BTN: {
    symbolNative: 'Nu.',
    minorSingle: 'Chetrum',
    minorPlural: 'Chetrums'
  },
  BWP: {
    symbolNative: 'P',
    minorSingle: 'Thebe',
    minorPlural: 'Thebe'
  },
  BYN: {
    symbolNative: 'руб.',
    minorSingle: 'Kapiejka',
    minorPlural: 'Kapiejka'
  },
  BZD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  CAD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  CDF: {
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  CHF: {
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  CKD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  CLP: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  CNY: {
    symbolNative: '¥元',
    minorSingle: 'Fen',
    minorPlural: 'Fen'
  },
  COP: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  CRC: {
    symbolNative: '₡',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos'
  },
  CUC: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  CUP: {
    symbolNative: '₱',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  CVE: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  CZK: {
    symbolNative: 'Kč',
    minorSingle: 'Haléř',
    minorPlural: 'Haléř'
  },
  DJF: {
    symbolNative: 'ف.ج.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  DKK: {
    symbolNative: 'kr.',
    minorSingle: 'Øre',
    minorPlural: 'Øre'
  },
  DOP: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  DZD: {
    symbolNative: 'د.ج.',
    minorSingle: 'Santeem',
    minorPlural: 'Santeems'
  },
  EGP: {
    symbolNative: 'ج.م.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh'
  },
  EHP: {
    symbolNative: 'Ptas.',
    minorSingle: 'Céntimo',
    minorPlural: 'Céntimos'
  },
  ERN: {
    symbolNative: 'ناكفا',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  ETB: {
    symbolNative: 'ብር',
    minorSingle: 'Santim',
    minorPlural: 'Santim'
  },
  EUR: {
    symbolNative: '€',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  FJD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  FKP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  FOK: {
    symbolNative: 'kr',
    minorSingle: 'Oyra',
    minorPlural: 'Oyra'
  },
  GBP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  GEL: {
    symbolNative: '₾',
    minorSingle: 'Tetri',
    minorPlural: 'Tetri'
  },
  GGP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  GHS: {
    symbolNative: '₵',
    minorSingle: 'Pesewa',
    minorPlural: 'Pesewas'
  },
  GIP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  GMD: {
    symbolNative: 'D',
    minorSingle: 'Butut',
    minorPlural: 'Bututs'
  },
  GNF: {
    symbolNative: 'FG',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  GTQ: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  GYD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  HKD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  HNL: {
    symbolNative: 'L',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  HRK: {
    symbolNative: 'kn',
    minorSingle: 'Lipa',
    minorPlural: 'Lipa'
  },
  HTG: {
    symbolNative: 'G',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  HUF: {
    symbolNative: 'Ft',
    minorSingle: 'fillér',
    minorPlural: 'fillér'
  },
  IDR: {
    symbolNative: 'Rp',
    minorSingle: 'Sen',
    minorPlural: 'Sen'
  },
  ILS: {
    symbolNative: '₪',
    minorSingle: 'Agora',
    minorPlural: 'Agoras'
  },
  IMP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  INR: {
    symbolNative: '₹',
    minorSingle: 'Paisa',
    minorPlural: 'Paise'
  },
  IQD: {
    symbolNative: 'د.ع.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  IRR: {
    symbolNative: '﷼',
    minorSingle: 'Dinar',
    minorPlural: 'Dinars'
  },
  ISK: {
    symbolNative: 'kr',
    minorSingle: 'Aurar',
    minorPlural: 'Aurar'
  },
  JEP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  JMD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  JOD: {
    symbolNative: 'د.أ.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  JPY: {
    symbolNative: '¥',
    minorSingle: 'Sen',
    minorPlural: 'Sen'
  },
  KES: {
    symbolNative: 'KSh',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  KGS: {
    symbolNative: 'с',
    minorSingle: 'Tyiyn',
    minorPlural: 'Tyiyn'
  },
  KHR: {
    symbolNative: '៛',
    minorSingle: 'Sen',
    minorPlural: 'Sen'
  },
  KID: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  KMF: {
    symbolNative: 'CF',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  KPW: {
    symbolNative: '₩',
    minorSingle: 'Chon',
    minorPlural: 'Chon'
  },
  KRW: {
    symbolNative: '₩',
    minorSingle: 'Jeon',
    minorPlural: 'Jeon'
  },
  KWD: {
    symbolNative: 'د.ك.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  KYD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  KZT: {
    symbolNative: '₸',
    minorSingle: 'Tıyn',
    minorPlural: 'Tıyn'
  },
  LAK: {
    symbolNative: '₭',
    minorSingle: 'Att',
    minorPlural: 'Att'
  },
  LBP: {
    symbolNative: 'ل.ل.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh'
  },
  LKR: {
    symbolNative: 'රු or ரூ',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  LRD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  LSL: {
    symbolNative: 'L',
    minorSingle: 'Sente',
    minorPlural: 'Lisente'
  },
  LYD: {
    symbolNative: 'ل.د.',
    minorSingle: 'Dirham',
    minorPlural: 'Dirhams'
  },
  MAD: {
    symbolNative: 'د.م.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  MDL: {
    symbolNative: 'L',
    minorSingle: 'Ban',
    minorPlural: 'Bani'
  },
  MGA: {
    symbolNative: 'Ar',
    minorSingle: 'Iraimbilanja',
    minorPlural: 'Iraimbilanja'
  },
  MKD: {
    symbolNative: 'ден',
    minorSingle: 'Deni',
    minorPlural: 'Deni'
  },
  MMK: {
    symbolNative: 'Ks',
    minorSingle: 'Pya',
    minorPlural: 'Pya'
  },
  MNT: {
    symbolNative: '₮',
    minorSingle: 'möngö',
    minorPlural: 'möngö'
  },
  MOP: {
    symbolNative: 'MOP$',
    minorSingle: 'Avo',
    minorPlural: 'Avos'
  },
  MRU: {
    symbolNative: 'أ.م.',
    minorSingle: 'Khoums',
    minorPlural: 'Khoums'
  },
  MUR: {
    symbolNative: 'रु ',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  MVR: {
    symbolNative: '.ރ',
    minorSingle: 'laari',
    minorPlural: 'laari'
  },
  MWK: {
    symbolNative: 'MK',
    minorSingle: 'Tambala',
    minorPlural: 'Tambala'
  },
  MXN: {
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  MYR: {
    symbolNative: 'RM',
    minorSingle: 'Sen',
    minorPlural: 'Sen'
  },
  MZN: {
    symbolNative: 'MT',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  NAD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  NGN: {
    symbolNative: '₦',
    minorSingle: 'Kobo',
    minorPlural: 'Kobo'
  },
  NIO: {
    symbolNative: 'C$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  NOK: {
    symbolNative: 'kr',
    minorSingle: 'øre',
    minorPlural: 'øre'
  },
  NPR: {
    symbolNative: 'रू',
    minorSingle: 'Paisa',
    minorPlural: 'Paise'
  },
  NZD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  OMR: {
    symbolNative: 'ر.ع.',
    minorSingle: 'Baisa',
    minorPlural: 'Baisa'
  },
  PAB: {
    symbolNative: 'B/.',
    minorSingle: 'Centésimo',
    minorPlural: 'Centésimos'
  },
  PEN: {
    symbolNative: 'S/.',
    minorSingle: 'Céntimo',
    minorPlural: 'Céntimos'
  },
  PGK: {
    symbolNative: 'K',
    minorSingle: 'Toea',
    minorPlural: 'Toea'
  },
  PHP: {
    symbolNative: '₱',
    minorSingle: 'Sentimo',
    minorPlural: 'Sentimo'
  },
  PKR: {
    symbolNative: 'Rs',
    minorSingle: 'Paisa',
    minorPlural: 'Paise'
  },
  PLN: {
    symbolNative: 'zł',
    minorSingle: 'Grosz',
    minorPlural: 'Groszy'
  },
  PND: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  PRB: {
    symbolNative: 'р.',
    minorSingle: 'Kopek',
    minorPlural: 'Kopeks'
  },
  PYG: {
    symbolNative: '₲',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos'
  },
  QAR: {
    symbolNative: 'ر.ق.',
    minorSingle: 'Dirham',
    minorPlural: 'Dirhams'
  },
  RON: {
    symbolNative: 'L',
    minorSingle: 'Ban',
    minorPlural: 'Bani'
  },
  RSD: {
    symbolNative: 'дин',
    minorSingle: 'Para',
    minorPlural: 'Para'
  },
  RUB: {
    symbolNative: '₽',
    minorSingle: 'Kopek',
    minorPlural: 'Kopeks'
  },
  RWF: {
    symbolNative: 'R₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  SAR: {
    symbolNative: 'ر.س.',
    minorSingle: 'Halalah',
    minorPlural: 'Halalahs'
  },
  SBD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SCR: {
    symbolNative: 'Rs',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SDG: {
    symbolNative: 'ج.س.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh'
  },
  SEK: {
    symbolNative: 'kr',
    minorSingle: 'Öre',
    minorPlural: 'Öre'
  },
  SGD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SHP: {
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence'
  },
  SLL: {
    symbolNative: 'Le',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SLS: {
    symbolNative: 'Sl',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SOS: {
    symbolNative: 'Ssh',
    minorSingle: 'Senti',
    minorPlural: 'Senti'
  },
  SRD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  SSP: {
    symbolNative: 'SS£',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh'
  },
  STN: {
    symbolNative: 'Db',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos'
  },
  SVC: {
    symbolNative: '₡',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos'
  },
  SYP: {
    symbolNative: 'ل.س.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh'
  },
  SZL: {
    symbolNative: 'L',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  THB: {
    symbolNative: '฿',
    minorSingle: 'Satang',
    minorPlural: 'Satang'
  },
  TJS: {
    symbolNative: 'SM',
    minorSingle: 'Diram',
    minorPlural: 'Diram'
  },
  TMT: {
    symbolNative: 'T',
    minorSingle: 'Tenge',
    minorPlural: 'Tenge'
  },
  TND: {
    symbolNative: 'د.ت.',
    minorSingle: 'Millime',
    minorPlural: 'Millime'
  },
  TOP: {
    symbolNative: 'PT',
    minorSingle: 'Seniti',
    minorPlural: 'Seniti'
  },
  TRY: {
    symbolNative: '₺',
    minorSingle: 'Kuruş',
    minorPlural: 'Kuruş'
  },
  TTD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  TVD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  TWD: {
    symbolNative: '圓',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  TZS: {
    symbolNative: 'TSh',
    minorSingle: 'Senti',
    minorPlural: 'Senti'
  },
  UAH: {
    symbolNative: 'грн',
    minorSingle: 'Kopiyka',
    minorPlural: 'kopiyky'
  },
  UGX: {
    symbolNative: 'Sh',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  USD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  UYU: {
    symbolNative: '$',
    minorSingle: 'Centésimo',
    minorPlural: 'Centésimos'
  },
  UZS: {
    symbolNative: 'сум',
    minorSingle: 'Tiyin',
    minorPlural: 'Tiyin'
  },
  VED: {
    symbolNative: 'Bs.',
    minorSingle: 'Céntimo',
    minorPlural: 'Céntimos'
  },
  VES: {
    symbolNative: 'Bs.F',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos'
  },
  VND: {
    symbolNative: '₫',
    minorSingle: 'Hào',
    minorPlural: 'Hào'
  },
  VUV: {
    symbolNative: 'VT',
    minorSingle: '',
    minorPlural: ''
  },
  WST: {
    symbolNative: 'ST',
    minorSingle: 'Sene',
    minorPlural: 'Sene'
  },
  XAF: {
    symbolNative: 'Fr.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  XCD: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  XOF: {
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  XPF: {
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes'
  },
  YER: {
    symbolNative: 'ر.ي.',
    minorSingle: 'Fils',
    minorPlural: 'Fils'
  },
  ZAR: {
    symbolNative: 'R',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  ZMW: {
    symbolNative: 'ZK',
    minorSingle: 'Ngwee',
    minorPlural: 'Ngwee'
  },
  ZWB: {
    symbolNative: '',
    minorSingle: '',
    minorPlural: ''
  },
  ZWL: {
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents'
  },
  Abkhazia: {
    symbolNative: '',
    minorSingle: '',
    minorPlural: ''
  },
  Artsakh: {
    symbolNative: 'դր.',
    minorSingle: 'Luma',
    minorPlural: 'Luma'
  }
};
